/* eslint-disable jira/filename-case */
import { get } from '@jira/onboarding__onboarding-browser-storage/src/controllers/index.tsx';

/**
 * Returns the team type a user selected via survey
 * during the onboarding flow.
 */
export const getTeamType = (): string | null => {
	const teamType = get('teamType');

	if (!teamType || typeof teamType.value !== 'string') {
		return null;
	}

	return teamType.value;
};

export const getOnboardingParams = (): {
	teamType: string | null;
} => ({
	teamType: getTeamType(),
});
